export interface Skill {
  id: string;
  workspaceId: string;
  name: string;
  description: string;
  instructions: string;
  enabled: boolean;
  createdBy: string | null;
  updatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

/** List/menu projection from `skills.list` — instruction body comes from `skills.get`. */
export type SkillSummary = Omit<Skill, 'instructions'>;

export function getSkillPath(id: string): string {
  return `/context/skill/${id}`;
}
